import type { ISchedulerTask, TaskId } from '@interfaces/IScheduler';
import type { ILadder } from '../lib/ladder';
import { useTaskLadder } from './useActivityLadder';

type LadderTask = Pick<ISchedulerTask, 'id' | 'status' | 'committed' | 'kind'>;

/**
 * The ladder rung of a task that may not have resolved from the store yet.
 *
 * The drawer's blocks read their task by id and render nothing while it is
 * missing — but hooks run unconditionally (rules of hooks), so `useTaskLadder`
 * has to be called BEFORE that early return. Until the task exists, this reads
 * the ladder of a plain, uncommitted field task standing in for it. Nothing
 * renders from that reading: every caller bails out on the missing task right
 * after, so the stand-in only has to be well-formed, not meaningful.
 */
export function useTaskLadderOrPlanned(task: LadderTask | undefined, taskId: TaskId): ILadder {
  return useTaskLadder(task ?? { id: taskId, status: 'planned', committed: false, kind: 'field' });
}
